module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraLight.5c37a74.woff2";